'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Renders a pair of buttons for adding or removing fields.
 * @extends {Component}
 */
var ButtonControllerComponent = function (_React$Component) {
  _inherits(ButtonControllerComponent, _React$Component);

  function ButtonControllerComponent() {
    _classCallCheck(this, ButtonControllerComponent);

    return _possibleConstructorReturn(this, (ButtonControllerComponent.__proto__ || Object.getPrototypeOf(ButtonControllerComponent)).apply(this, arguments));
  }

  _createClass(ButtonControllerComponent, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _reactBootstrap.Grid,
        { fluid: true, className: 'ingle-form-button-controller' },
        _react2.default.createElement(
          _reactBootstrap.Row,
          null,
          _react2.default.createElement(
            _reactBootstrap.Col,
            { xs: 12 },
            _react2.default.createElement(
              'div',
              { className: 'div-center' },
              _react2.default.createElement(
                _reactBootstrap.Button,
                {
                  bsStyle: 'success',
                  onClick: this.props.addButtonDispatcher,
                  disabled: this.props.disableAdd
                },
                this.props.addButtonGlyph && _react2.default.createElement(_reactBootstrap.Glyphicon, { glyph: this.props.addButtonGlyph }),
                this.props.addButtonGlyph ? ' ' + this.props.addButtonContent : this.props.addButtonContent
              ),
              ' ',
              _react2.default.createElement(
                _reactBootstrap.Button,
                {
                  bsStyle: 'danger',
                  onClick: this.props.removeButtonDispatcher,
                  disabled: this.props.disableRemove
                },
                this.props.removeButtonGlyph && _react2.default.createElement(_reactBootstrap.Glyphicon, { glyph: this.props.removeButtonGlyph }),
                this.props.removeButtonGlyph ? ' ' + this.props.removeButtonContent : this.props.removeButtonContent
              )
            )
          )
        )
      );
    }
  }]);

  return ButtonControllerComponent;
}(_react2.default.Component);

ButtonControllerComponent.propTypes = {
  disableAdd: _react2.default.PropTypes.bool,
  disableRemove: _react2.default.PropTypes.bool,
  addButtonGlyph: _react2.default.PropTypes.string,
  addButtonContent: _react2.default.PropTypes.string,
  addButtonDispatcher: _react2.default.PropTypes.func.isRequired,
  removeButtonGlyph: _react2.default.PropTypes.string,
  removeButtonContent: _react2.default.PropTypes.string,
  removeButtonDispatcher: _react2.default.PropTypes.func.isRequired
};
ButtonControllerComponent.defaultProps = {
  disableAdd: false,
  disableRemove: false,
  addButtonContent: 'Add',
  removeButtonContent: 'Remove'
};
exports.default = ButtonControllerComponent;


//////////////////
// WEBPACK FOOTER
// ./src/v2/components/common/dynamic/ButtonControllerComponent.jsx
// module id = 405
// module chunks = 0